<template>
	<div class="plugins-pos-container">
		<CardSlashedTapToPay />
		<PosSettingsCard ref="pos-list" @delete-terminal="clickDeleteTerminal" @delete-pax-terminal="clickDeletePaxTerminal" @delete-dojo-terminal="clickDeleteDojoTerminal" @save-settings="clickSaveSettings" @save-pax-settings="clickSavePaxSettings" @save-dojo-settings="clickSaveDojoSettings"/>
		<PosStatusCard @save-status="clickSaveStatus" class="card-margin d-n" />
		<CardSlashed v-if="!this.userStore.businessTerminals || this.userStore.businessTerminals.length >= 1" class="card-link card-link-secondary card-margin">
			<template #left>
				<div class="card-link-title">
					<div class="icon-plugins" v-html="getIcon('iconPos')"></div>
					<div class="align-text">
						<h2>{{getString('do_you_need_more_pos')}}</h2>
						<p>{{getString('take_advantage_of_the_promotion')}}</p>
					</div>
				</div>
			</template>
			<template #right>
				<div class="col-12 align-end card-link-body p-3">
					<div class="card-link-actions" v-if="userStore.currBusiness">
						<AppButton
							@click="GoToShop"
							:text="getString('go_to_shop')"
							outline
							inverted
						/>
					</div>
				</div>
			</template>
		</CardSlashed>

		<AppPopup
			ref="delete-terminal-popup"
			:title="getString('delete_terminal_popup_title', [this.deletingTerminal ? this.deletingTerminal.name : ''])"
			:bodyText="getString('delete_terminal_popup_message')"
			:buttons="deleteTerminalPopupButtons"
		/>
		<AppPopup
			ref="delete-pax-terminal-popup"
			:title="getString('delete_terminal_popup_title', [this.deletingTerminal ? this.deletingTerminal.name : ''])"
			:bodyText="getString('delete_terminal_popup_message')"
			:buttons="deletePaxTerminalPopupButtons"
		/>
		<AppPopup
			ref="delete-dojo-terminal-popup"
			:title="getString('delete_terminal_popup_title', [this.deletingTerminal ? this.deletingTerminal.name : ''])"
			:bodyText="getString('delete_terminal_dojo_popup_message')"
			:buttons="deleteDojoTerminalPopupButtons"
		/>
	</div>
</template>

<script>
import PosStatusCard from "@/console-new/components/plugins/PosStatusCard.vue";
import PosSettingsCard from "@/console-new/components/plugins/PosSettingsCard.vue";
import {useCurrencyStore, useLanguageStore, useNotificationStore, useSvgStore} from "@/shared/stores";
import {useUserStore} from "@/console-new/stores";
import {useShopStore} from "@/shop/stores";
import AppPopup from "@/shared/components/AppPopup.vue";
import CardSlashed from "@/console-new/components/shared/CardSlashed.vue";
import AppButton from "@/shared/components/AppButton.vue";
import ModalHeader from "@/console-new/components/shared/ModalHeader.vue";
import CardSlashedTapToPay from "@/console-new/components/shared/CardSlashedTapToPay.vue";


export default {
	setup() {
		let languageStore = useLanguageStore();
		let userStore = useUserStore();
		let svgStore = useSvgStore();
		const shopStore = useShopStore();
		const notificationStore = useNotificationStore();
		const currencyStore = useCurrencyStore();
		return {getString: languageStore.getString, currencyStore, showNotification: notificationStore.showNotification, userStore, shopStore, getIcon: svgStore.get}
	},
	name: "PluginsPos",
	data() {
		return {
			loadingStatus: false,
			loadingSettings: false,
			deletingTerminal: null,
			posItem: {id:'qromopos'},
		}
	},
	components: {CardSlashedTapToPay, ModalHeader, AppButton, CardSlashed, AppPopup, PosStatusCard, PosSettingsCard},
	computed: {
		deleteTerminalPopupButtons() {
			return [
				{
					text: this.getString('cancel'),
					negative: true,
					callback: () => {this.$refs["delete-terminal-popup"].toggleStatus(false);}
				},
				{
					text: this.getString('delete'),
					callback: () => {
						this.$refs["delete-terminal-popup"].toggleStatus(false);
						this.deleteTerminal();
					}
				}
			]
		},
		deletePaxTerminalPopupButtons() {
			return [
				{
					text: this.getString('cancel'),
					negative: true,
					callback: () => {this.$refs["delete-pax-terminal-popup"].toggleStatus(false);}
				},
				{
					text: this.getString('delete'),
					callback: () => {
						this.$refs["delete-pax-terminal-popup"].toggleStatus(false);
						this.deletePaxTerminal();
					}
				}
			]
		},
		deleteDojoTerminalPopupButtons() {
			return [
				{
					text: this.getString('cancel'),
					negative: true,
					callback: () => {this.$refs["delete-dojo-terminal-popup"].toggleStatus(false);}
				},
				{
					text: this.getString('delete'),
					callback: () => {
						this.$refs["delete-dojo-terminal-popup"].toggleStatus(false);
						this.deleteDojoTerminal();
					}
				}
			]
		},
	},
	methods: {
		clickSaveStatus() {
			if(this.loadingStatus) { return; }
			if(!this.userStore.currBusiness.config_settings) {
				this.showNotification('pos-settings-warn');
			} else if(!this.userStore.currBusiness.config_payments) {
				this.showNotification('pos-payments-warn');
			} else {
				this.loadingStatus = true;
				this.userStore.updateBusiness({pos: this.userStore.currBusiness.pos},success=>{
					this.loadingStatus = false;
					this.showNotification(success ? 'pos-status-updated' : 'generic-fail');
				});
			}
		},
		clickSaveSettings(newTerminal, callback) {
			if(this.loadingSettings) { return; }
			if((!this.userStore.businessTerminals || !this.userStore.businessTerminals.length) && !newTerminal) {
				this.showNotification('nothing-to-save');
				return;
			}
			this.loadingSettings = true;
			this.userStore.updateBusinessTerminals(newTerminal, (success, details) => {
				this.loadingSettings = false;
				if(success) {
					callback && callback();
					this.showNotification('generic-success');
				} else {
					let msg = details === 'missing_valid_address' ? 'missing-valid-address' : 'generic-fail';
					msg = details === 'wrong_code' ? 'wrong-pos-code' : msg;
					this.showNotification(msg);
				}
			})
		},
		clickSavePaxSettings(newTerminal, callback) {
			if(this.loadingSettings) { return; }
			if((!this.userStore.paxTerminals || !this.userStore.paxTerminals.length) && !newTerminal) {
				this.showNotification('nothing-to-save');
				return;
			}
			this.loadingSettings = true;
			this.userStore.updatePaxTerminals(newTerminal, (success, details) => {
				this.loadingSettings = false;
				if(success) {
					callback && callback();
					this.showNotification('generic-success');
				} else {
					let msg = details === 'pax_add_reader_error' ? 'wrong-pos-code' : 'generic-fail';
					this.showNotification(msg);
				}
			})
		},
		clickSaveDojoSettings(newTerminal, callback) {
			if(this.loadingSettings) { return; }
			if((!this.userStore.dojoTerminals || !this.userStore.dojoTerminals.length) && !newTerminal) {
				this.showNotification('nothing-to-save');
				return;
			}
			this.loadingSettings = true;
			this.userStore.updateDojoTerminals(newTerminal, (success, details) => {
				this.loadingSettings = false;
				if(success) {
					callback && callback();
					this.showNotification('generic-success');
				} else {
					let msg = details === 'dojo_terminal_not_found' ? 'wrong-pos-code' : 'generic-fail';
					this.showNotification(msg);
				}
			})
		},
		clickDeletePaxTerminal(terminal) {
			if(this.loadingSettings) { return; }
			this.deletingTerminal = terminal;
			this.$refs["delete-pax-terminal-popup"].toggleStatus(true);
		},
		clickDeleteDojoTerminal(terminal) {
			if(this.loadingSettings) { return; }
			this.deletingTerminal = terminal;
			this.$refs["delete-dojo-terminal-popup"].toggleStatus(true);
		},
		deletePaxTerminal() {
			if(this.loadingSettings || !this.deletingTerminal) { return; }
			this.loadingSettings = true;
			this.userStore.deleteTerminalPax(this.deletingTerminal.id, (success, details) => {
				this.loadingSettings = false;
				this.showNotification(success ? 'generic-success' : 'generic-fail');
				this.$refs["delete-pax-terminal-popup"].toggleStatus(false);
			})
		},
		deleteDojoTerminal() {
			if(this.loadingSettings || !this.deletingTerminal) { return; }
			this.loadingSettings = true;
			this.userStore.deleteTerminalDojo(this.deletingTerminal.id, (success, details) => {
				this.loadingSettings = false;
				this.showNotification(success ? 'generic-success' : 'generic-fail');
				this.$refs["delete-dojo-terminal-popup"].toggleStatus(false);
			})
		},
		clickDeleteTerminal(terminal) {
			if(this.loadingSettings) { return; }
			this.deletingTerminal = terminal;
			this.$refs["delete-terminal-popup"].toggleStatus(true);
		},
		deleteTerminal() {
			if(this.loadingSettings || !this.deletingTerminal) { return; }
			this.loadingSettings = true;
			this.userStore.deleteTerminal(this.deletingTerminal.id, (success, details) => {
				this.loadingSettings = false;
				this.showNotification(success ? 'generic-success' : 'generic-fail');
				this.$refs["delete-terminal-popup"].toggleStatus(false);
			})
		},
		GoToShop() {
			this.$router.push("/plugins/shop");
		},
		init() {
			if(!this.userStore?.businessUsers?.length) {
				this.userStore.getBusinessUsers(()=>{
					this.userStore.getBusinessTerminals(false);
				});
			} else {
				this.userStore.getBusinessTerminals(false);
			}
		}
	},
	created() {
		this.init();
	},
	watch: {
		'userStore.currBusinessId': {
			handler(newVal, oldVal) {
				if(newVal && newVal !== oldVal) {
					this.init();
				}
			},
		},
	},
}
</script>

<style lang="scss" scoped>
.plugins-pos-container {
	max-width: 1400px;
	margin: 0 auto;
	.card-link {
		box-shadow: 0 3px 25px var(--color-box-shadow-3), inset 1px 20px black;
		.card-link-title {
			width: 100%;
			display: flex;
			align-items: flex-start;
			justify-content: flex-start;
			.icon-plugins {
				display: inline-block;
				width: 15px;
				height: 15px;
				margin-top: 5px;

				&:deep(svg) {
					width: 15px;
					height: 15px;
					.fill { fill: var(--color-txt-white); }
					.stroke { stroke: var(--color-txt-white); }
				}
			}
			.align-text {
				display:flex;
				flex-direction: column;
			}
			h2 {
				font-size: 22px;
				display: inline-block;
				padding-left: 8px;
				color: var(--color-txt-white);
				@media (max-width: 500px) {
					font-size: 20px;
					line-height: normal;
				}
			}
			p {
				font-size: 14px;
				line-height: 18px;
				color: var(--color-txt-white);
				margin-left: 8px;
				margin-top: 5px;
			}
			&.no-icon {
				h2 {
					width: 100%;
					padding-left: 0;
				}
			}
		}
		.card-link-body {
			height: 100%;
			gap: 20px;
			.card-link-actions {
				position: relative;
				.align-row-item {
					display: flex;
					align-items: center;
					justify-content: center;
					gap: 20px;
					.button-download {
						width: auto;
						height: 40px;
						display: flex;
						align-items: center;
						img {
							object-fit: contain;
							width: 100%;
							height: 100%;
						}
					}
				}
			}
		}
		&-secondary {
			&:deep(.slashed-card-container) {
				background: linear-gradient(198deg, rgb(139, 61, 245) 0%, rgb(47, 36, 209) 100%);
				.slashed-left {
					background-color: rgba(7, 82, 163, 0.1);
					@media (max-width: 500px) {
						padding-right: 10px;
						padding-bottom: 10px;

					}
					&::after {
						border-left: 1px solid var(--color-primary);
						@media (max-width: 500px) {
							border-left: none;
							border-top: 1px solid var(--color-primary);
						}
					}
				}
				.slashed-right {
					@media (max-width: 500px) {
						padding-top: 0;
					}
				}
			}
			.align-end {
				align-self: flex-end;
				justify-content: flex-end;
			}
		}
	}
	.card-margin {
		margin-top: var(--main-padding);
	}
	.card-margin-bottom {
		margin-bottom: var(--main-padding);
	}
	.wrapper-img {
		width: 100%;
		height: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
		picture {
			img {
				width: 100%;
				height: 100%;
				max-height: 220px;
				object-fit: contain;
				@media (max-width: 500px) {
					max-height: 190px;
				}
			}
		}
	}
	:deep(.card-container .card-body) {
		padding: 0;
		& > .list-container {
			.list-item:first-child::before {
				display: none;
			}
			.list-item:last-child::after {
				display: none;
			}
		}
	}
}
</style>